import { PDFDocument } from 'pdf-lib';

export class Pdf {
  public static async merge(pdfFiles: Blob[]): Promise<Blob> {
      const merger = await PDFDocument.create();
      for (const pdfCopyDoc of pdfFiles) {
        const buffer = await pdfCopyDoc.arrayBuffer();
        const mergee = await PDFDocument.load(buffer);
        const pages = await merger.copyPages(mergee, mergee.getPageIndices());
        pages.forEach(page => merger.addPage(page));
      }
      return new Blob([await merger.save()]);
  }
}
